// extracted by mini-css-extract-plugin
var _1 = "ListPoint_centerOfPoint__969bc";
export { _1 as "centerOfPoint" }
